import { render, staticRenderFns } from "./SelectModality.vue?vue&type=template&id=3c717a22"
import script from "./SelectModality.vue?vue&type=script&lang=js"
export * from "./SelectModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports